// Port of api/fuel/app/classes/controller/api/monty/session/externaldomains.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Group from 'offline/model/group'
import User from 'offline/model/user'
import PlatformExternaldomain from 'offline/model/platform/externaldomain'

function sessionUserId(params) {
	return params.sessionUserId || DB.meta('sync_user_id') || false
}

function now() {
	return Math.floor(Date.now() / 1000)
}

function externaldomainData(item) {
	if (!item) return false

	var user = User.with_id(item.get_user_id())
	var date = parseInt(item.get_date(), 10) || 0

	return {
		id: parseInt(item.get_id(), 10) || 0,
		value: item.get_value(),
		ready: parseInt(item.get_status(), 10) || 0,
		status: parseInt(item.get_status(), 10) || 0,
		date: date,
		user: user ? user.get_name() : '',
		recipient: parseInt(item.get_recipient(), 10) || 0,
		canCancel: !item.get_status(),
		canRemove: !!(item.get_status() && (Date.now() / 1000) >= (date + Constants.TIME_WEEK)),
		removeDate: date + Constants.TIME_WEEK
	}
}

function groupPayload(group, request) {
	if (!group) return false
	var data = group.to_array()
	data.externaldomain = request ? request.value : false
	return data
}

export default function(params) {
	var method = params.__offlineMethod || 'GET'
	var userId = sessionUserId(params)
	var sessionUser = userId ? User.with_id(userId) : false

	if (!userId) {
		return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
	}

	if (method !== 'GET') {
		if (!sessionUser) {
			return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
		}

		if (method === 'POST') {
			var type = params.type || false
			var value = String(params.value || '').trim().toLowerCase()
			var selectedGroup = false

			if (!value) {
				return Promise.reject({ error: 'Invalid external domain request.', offline: true })
			}

			if (type === 'user') {
				var userExternaldomain = PlatformExternaldomain.record({
					where: [
						['user_id', '=', userId],
						['externaldomain_recipient', '=', userId],
						['externaldomain_type', '=', Constants.TYPE_USER]
					]
				})

				if (userExternaldomain && userExternaldomain.get_status() && userExternaldomain.get_date() > (now() - Constants.TIME_WEEK)) {
					return Promise.reject({ error: 'External domain cannot be changed yet.', offline: true })
				}

				if (userExternaldomain && !userExternaldomain.get_status()) {
					DB.run('UPDATE platform_externaldomain SET externaldomain_value = ? WHERE externaldomain_id = ?', [value, userExternaldomain.get_id()])
				} else {
					DB.run('INSERT INTO platform_externaldomain (user_id, externaldomain_date, externaldomain_status, externaldomain_type, externaldomain_recipient, externaldomain_value) VALUES (?, ?, ?, ?, ?, ?)', [
						userId, now(), 0, Constants.TYPE_USER, userId, value
					])
				}

				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: { group: false }
					}
				})
			}

			if (type === 'group') {
				var groupId = parseInt(params.group, 10) || 0
				var userGroupExternaldomain = PlatformExternaldomain.record({
					where: [
						['user_id', '=', userId],
						['externaldomain_type', '=', Constants.TYPE_GROUP]
					]
				})

				selectedGroup = Group.with_id(groupId)

				if (!selectedGroup || parseInt(selectedGroup.get_user_id(), 10) !== userId) {
					return Promise.reject({ error: 'Invalid group request.', offline: true })
				}

				if (userGroupExternaldomain && parseInt(userGroupExternaldomain.get_recipient(), 10) !== groupId) {
					return Promise.reject({ error: 'Group external domain already assigned elsewhere.', offline: true })
				}

				if (userGroupExternaldomain && userGroupExternaldomain.get_status() && userGroupExternaldomain.get_date() > (now() - Constants.TIME_WEEK)) {
					return Promise.reject({ error: 'External domain cannot be changed yet.', offline: true })
				}

				if (!userGroupExternaldomain) {
					var reservedGroup = PlatformExternaldomain.record({
						where: [
							['user_id', '<>', userId],
							['externaldomain_type', '=', Constants.TYPE_GROUP],
							['externaldomain_recipient', '=', groupId]
						]
					})
					if (reservedGroup) {
						return Promise.reject({ error: 'Group external domain already requested.', offline: true })
					}
				}

				var usedExternaldomain = PlatformExternaldomain.record({
					where: [
						['externaldomain_id', '<>', userGroupExternaldomain ? userGroupExternaldomain.get_id() : 0],
						['externaldomain_value', '=', value]
					]
				})

				if (usedExternaldomain) {
					return Promise.reject({ error: 'External domain already taken.', offline: true })
				}

				if (userGroupExternaldomain && !userGroupExternaldomain.get_status()) {
					DB.run('UPDATE platform_externaldomain SET externaldomain_value = ? WHERE externaldomain_id = ?', [value, userGroupExternaldomain.get_id()])
				} else {
					DB.run('INSERT INTO platform_externaldomain (user_id, externaldomain_date, externaldomain_status, externaldomain_type, externaldomain_recipient, externaldomain_value) VALUES (?, ?, ?, ?, ?, ?)', [
						userId, now(), 0, Constants.TYPE_GROUP, groupId, value
					])
				}

				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: {
							group: groupPayload(selectedGroup, { value: value })
						}
					}
				})
			}

			return Promise.reject({ error: 'Invalid external domain request.', offline: true })
		}

		if (method === 'DELETE') {
			var deleteType = params.type || false

			if (deleteType === 'user') {
				DB.run('DELETE FROM platform_externaldomain WHERE user_id = ? AND externaldomain_recipient = ? AND externaldomain_type = ?', [
					userId, userId, Constants.TYPE_USER
				])
				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: { group: false }
					}
				})
			}

			if (deleteType === 'group') {
				var existing = PlatformExternaldomain.record({
					where: [
						['user_id', '=', userId],
						['externaldomain_type', '=', Constants.TYPE_GROUP]
					]
				})
				var existingGroup = existing ? Group.with_id(existing.get_recipient()) : false

				DB.run('DELETE FROM platform_externaldomain WHERE user_id = ? AND externaldomain_type = ?', [
					userId, Constants.TYPE_GROUP
				])

				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: {
							group: groupPayload(existingGroup, false)
						}
					}
				})
			}

			return Promise.reject({ error: 'Invalid external domain request.', offline: true })
		}

		return Promise.reject({ error: 'This action is not available offline.', offline: true })
	}

	var user = PlatformExternaldomain.record({
		where: [
			['user_id', '=', userId],
			['externaldomain_type', '=', Constants.TYPE_USER]
		]
	})

	var group = PlatformExternaldomain.record({
		where: [
			['user_id', '=', userId],
			['externaldomain_type', '=', Constants.TYPE_GROUP]
		]
	})

	return Promise.resolve({
		session: { offline: true },
		data: {
			user: externaldomainData(user),
			group: externaldomainData(group),
			canGroup: sessionUser.get_upgrade() === Constants.USER_UPGRADE_GROUP
		}
	})
}
